//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import ServerAction from "../ServerAction.js";
import Pkg from "../../../apps/webCompanion/package.json";
const SetSdkVersionAction = class SetSdkVersionAction extends ServerAction {
  constructor() {
    super("SetSdkVersionAction");
    this.product = "webcompanion";
    this.version = Pkg.version;
  }
};

export default SetSdkVersionAction;
